import { CloseOutlined } from '@ant-design/icons';
import React from 'react';

interface Props {
    className?: string;
    manufacturing_type: string;
    material_name: string;
    finish_name: string | null;
    coating_name: string | null;
    has_material_cert?: boolean;
    remove_coating?: boolean;
    deviation_note?: string | null;
    handleUpdateProduct?: () => void;
    custom_material?: string;
    custom_finish?: string;
    custom_coating?: string;
}

const QuoteItemInformation = (props: Props) => {
    return (
        <div
            className={props.className ?? 'flex flex-col leading-tight'}
            style={{ minWidth: '260px', lineHeight: '1.5' }}
        >
            <div className="flex flex-row">
                <span className={'font-bold'}>Process:</span>
                <span className="ml-1"> {props.manufacturing_type}</span>
            </div>
            <div className="flex flex-row">
                <span className={'font-bold'}>Material:</span>
                <span className="ml-1">
                    {props.material_name === 'Custom' ? `Custom: ${props?.custom_material || ''}` : props.material_name}
                </span>
            </div>
            <div className="flex flex-row">
                <span className={'font-bold'}>Surface Finish:</span>
                <span className="ml-1">
                    {props.finish_name === 'Custom' ? `Custom: ${props?.custom_finish || ''}` : props.finish_name}
                </span>
            </div>
            <div className="flex flex-row">
                <span className={'font-bold'}>Coating:</span>
                <span className="ml-1">
                    {props.coating_name === 'Custom' ? `Custom: ${props?.custom_coating || ''}` : props.coating_name}
                </span>
            </div>
            {props.remove_coating && props.deviation_note && !props.coating_name && (
                <div className="flex flex-row">
                    <i>{props.deviation_note}</i>
                </div>
            )}

            {props.remove_coating && props.coating_name && props.coating_name !== 'None' && (
                <div className="text-red-600">
                    <span
                        className={'link'}
                        style={{ cursor: 'pointer' }}
                        onClick={() => props.handleUpdateProduct && props.handleUpdateProduct()}
                    >
                        Remove Coating
                    </span>
                </div>
            )}
            <div className="flex flex-row">
                <span className={'font-bold'}>Material Certificate:</span>
                <span className="ml-1">{props.has_material_cert ? 'Yes' : 'No'}</span>
            </div>
        </div>
    );
};

export default QuoteItemInformation;
